export enum LogDocumentType {
    Ride = '[LogDocumentType] ride',
    Media = '[LogDocumentType] media',
    Other = '[LogDocumentType] other'
}

export namespace LogDocumentType {
    export function toString(type: LogDocumentType): string {
        switch (type) {
            case LogDocumentType.Ride:
                return 'Ride';
            case LogDocumentType.Media:
                return 'Media';
            case LogDocumentType.Other:
                return 'Other';
            default:
                return '';
        }
    }
}
